'use strict';
var store = require('../internals/shared-store');

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/shared.js
// module id = 90
// module chunks = 13